import { ValidationRules } from '../../models/ValidationRuleNames.model';

import {
    ScheduledOrBlanketItemFieldValidator,
    createScheduledNameItemRequiredValidator,
    createScheduledOrBlanketSelfValidator,
} from './scheduledNamesRequired.validator';

type SubFieldKey = 'names' | '$item';

export function createScheduledOrBlanketSubFieldValidatorsMap(
    _nullable: boolean,
    customMessages?: Record<ValidationRules, string>,
): Record<SubFieldKey | '$self', ScheduledOrBlanketItemFieldValidator[]> {
    const customMsg = customMessages?.required;

    return {
        // Self validator for the entire object - validates that names array is not empty when SCHEDULED
        $self: [
            createScheduledOrBlanketSelfValidator({ customMsg }),
        ],
        // names field level - no direct validation needed (handled by $item)
        names: [],
        // $item - validates each name in the names array
        $item: [
            createScheduledNameItemRequiredValidator({ customMsg }),
        ],
    };
}
